export default __webpack_public_path__ + "static/media/ivana-square.f7bc23b2.jpg";